import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/[locale]/markets/[symbol]/MainMarketDetail.tsx");
import(/* webpackMode: "eager" */ "/opt/build/repo/src/asset/images/image-blog.png");
import(/* webpackMode: "eager" */ "/opt/build/repo/src/asset/images/image-example.png")